/* Vzorky zdarma (B2B) – sections/vzorky-zdarma.liquid
 * - company lookup in ARES (public API, CORS enabled)
 * - address suggestions from Mapy.com (only when an API key is set in the section)
 * - Walio code check, customer tags, hidden attribution fields
 * - after Shopify accepts the form, the data goes to the Make webhook, which creates the customer
 */
(function () {
  const ARES = 'https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty';
  const MAPY = 'https://api.mapy.com/v1/suggest';
  const PENDING_KEY = 'vz_pending';

  const norm = (s) =>
    String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const fmtZip = (z) => String(z || '').replace(/\s/g, '').replace(/^(\d{3})(\d{2})$/, '$1 $2');
  const storage = {
    get(k, store = sessionStorage) {
      try {
        return JSON.parse(store.getItem(k));
      } catch (e) {
        return null;
      }
    },
    set(k, v, store = sessionStorage) {
      try {
        store.setItem(k, JSON.stringify(v));
      } catch (e) {}
    },
    del(k, store = sessionStorage) {
      try {
        store.removeItem(k);
      } catch (e) {}
    },
  };

  function init(root) {
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const cfg = {
      mapyKey: root.dataset.mapyKey,
      webhook: root.dataset.webhook,
      code: (root.dataset.code || '').trim().toUpperCase(),
    };

    const done = $('[data-vz-done]');
    if (done) return finish(done, cfg);

    const form = $('form');
    if (!form) return;
    const hidden = (k) => $(`[data-vz-h="${k}"]`);
    let company = null;
    let manualCompany = false;

    /* ---------- suggestion list (shared) ---------- */
    function attachSuggest(input, box, { search, render, pick, label }) {
      let timer;
      let seq = 0;
      const ico = input.parentElement.querySelector('.vz-in-ico');
      const close = () => {
        box.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 3) return close();
        timer = setTimeout(async () => {
          const my = ++seq;
          ico && ico.classList.add('spin');
          let items = [];
          try {
            items = await search(q);
          } catch (e) {
            items = [];
          }
          ico && ico.classList.remove('spin');
          if (my !== seq) return;
          box.innerHTML = '';
          if (!items.length) return close();
          const head = document.createElement('div');
          head.className = 'src';
          head.textContent = label;
          box.append(head);
          items.forEach((it, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('role', 'option');
            b.id = `${box.id}-${i}`;
            b.innerHTML = render(it);
            b.addEventListener('mousedown', (e) => {
              e.preventDefault();
              pick(it);
              close();
            });
            box.append(b);
          });
          box.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }, 250);
      });
      input.addEventListener('keydown', (e) => {
        const bs = [...box.querySelectorAll('button')];
        if (box.hidden || !bs.length) return;
        let i = bs.findIndex((b) => b.classList.contains('act'));
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          bs[i] && bs[i].classList.remove('act');
          i = e.key === 'ArrowDown' ? (i + 1) % bs.length : (i - 1 + bs.length) % bs.length;
          bs[i].classList.add('act');
          bs[i].scrollIntoView({ block: 'nearest' });
          input.setAttribute('aria-activedescendant', bs[i].id);
        } else if (e.key === 'Enter' && i > -1) {
          e.preventDefault();
          bs[i].dispatchEvent(new MouseEvent('mousedown'));
        } else if (e.key === 'Escape') close();
      });
      input.addEventListener('blur', () => setTimeout(close, 150));
    }

    /* ---------- company (ARES) ---------- */
    function fromAres(x) {
      const s = x.sidlo || {};
      const num = [s.cisloDomovni, s.cisloOrientacni ? s.cisloOrientacni + (s.cisloOrientacniPismeno || '') : '']
        .filter(Boolean)
        .join('/');
      return {
        ico: x.ico,
        dic: x.dic || '',
        name: x.obchodniJmeno,
        addr: s.textovaAdresa || '',
        street: [s.nazevUlice || s.nazevCastiObce || s.nazevObce, num].filter(Boolean).join(' '),
        city: s.nazevObce || '',
        zip: fmtZip(s.psc),
      };
    }
    async function aresSearch(q) {
      const ico = q.replace(/\s/g, '');
      if (/^\d{8}$/.test(ico)) {
        const r = await fetch(`${ARES}/${ico}`, { headers: { Accept: 'application/json' } });
        return r.ok ? [fromAres(await r.json())] : [];
      }
      const r = await fetch(`${ARES}/vyhledat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ obchodniJmeno: q, pocet: 8 }),
      });
      if (!r.ok) return [];
      return ((await r.json()).ekonomickeSubjekty || []).map(fromAres);
    }
    const coQ = $('#vz-co-q');
    attachSuggest(coQ, $('#vz-co-sug'), {
      search: aresSearch,
      render: (c) => `${esc(c.name)}<small>IČO ${esc(c.ico)} · ${esc(c.addr)}</small>`,
      pick: setCompany,
      label: 'Výsledky z ARES',
    });
    function setCompany(c) {
      company = c;
      manualCompany = false;
      $('[data-vz-co-search]').hidden = true;
      $('[data-vz-co-search]').classList.remove('bad');
      $('[data-vz-co-manual-fields]').hidden = true;
      $('[data-vz-co-card]').hidden = false;
      $('[data-vz-co-name]').textContent = c.name;
      $('[data-vz-co-ico]').textContent = c.ico;
      $('[data-vz-co-dic]').textContent = c.dic || 'neplátce DPH';
      $('[data-vz-co-addr]').textContent = c.addr;
      $('[data-vz-same-wrap]').hidden = !c.street;
      progress();
    }
    $('[data-vz-co-change]').addEventListener('click', () => {
      company = null;
      $('[data-vz-co-card]').hidden = true;
      $('[data-vz-co-search]').hidden = false;
      $('[data-vz-same-wrap]').hidden = true;
      $('[data-vz-same]').checked = false;
      coQ.focus();
      progress();
    });
    $('[data-vz-co-manual]').addEventListener('click', () => {
      manualCompany = true;
      $('[data-vz-co-search]').hidden = true;
      $('[data-vz-co-manual-fields]').hidden = false;
      const name = $('#vz-co-name');
      if (!/^\d+$/.test(coQ.value.trim())) name.value = coQ.value.trim();
      else $('#vz-co-ico').value = coQ.value.trim();
      name.focus();
      progress();
    });
    $('[data-vz-same]').addEventListener('change', (e) => {
      if (e.target.checked && company) {
        $('#vz-addr').value = company.street;
        $('#vz-city').value = company.city;
        $('#vz-zip').value = company.zip;
        ['#vz-addr', '#vz-city', '#vz-zip'].forEach((s) => $(s).closest('.vz-f').classList.remove('bad'));
      }
      progress();
    });

    /* ---------- address (Mapy.com) ---------- */
    if (cfg.mapyKey) {
      attachSuggest($('#vz-addr'), $('#vz-addr-sug'), {
        search: async (q) => {
          const url = `${MAPY}?${new URLSearchParams({
            query: q,
            lang: 'cs',
            limit: '6',
            type: 'regional.address',
            locality: 'cz',
            apikey: cfg.mapyKey,
          })}`;
          const r = await fetch(url);
          if (!r.ok) return [];
          return ((await r.json()).items || []).map((it) => {
            const rs = it.regionalStructure || [];
            const city = (rs.find((x) => x.type === 'regional.municipality') || {}).name || '';
            return { street: it.name, city, zip: fmtZip(it.zip), where: it.location || city };
          });
        },
        render: (a) => `${esc(a.street)}<small>${esc(a.where)}${a.zip ? ' · ' + esc(a.zip) : ''}</small>`,
        pick: (a) => {
          $('#vz-addr').value = a.street;
          if (a.city) $('#vz-city').value = a.city;
          if (a.zip) $('#vz-zip').value = a.zip;
          ['#vz-addr', '#vz-city', '#vz-zip'].forEach((s) => $(s).closest('.vz-f').classList.remove('bad'));
          progress();
        },
        label: 'Návrhy adres',
      });
    }

    /* ---------- source + code ---------- */
    const other = $('[data-vz-src-other]');
    const codeBox = $('[data-vz-code-box]');
    function onSource() {
      const v = ($('[data-vz-src] input:checked') || {}).value;
      other.hidden = v !== 'Jiné';
      codeBox.hidden = v !== 'Walio';
      if (codeBox.hidden && codeIn.value) {
        codeIn.value = '';
        checkCode();
      }
    }
    $('[data-vz-src]').addEventListener('change', (e) => {
      onSource();
      if (e.target.value === 'Jiné') other.focus();
      if (e.target.value === 'Walio') codeIn.focus();
      progress();
    });
    $('[data-vz-biz]').addEventListener('change', progress);

    const codeIn = $('[data-vz-code]');
    const codeMsg = $('[data-vz-code-msg]');
    let codeOk = false;
    function checkCode() {
      const v = codeIn.value.trim().toUpperCase();
      codeOk = !!v && !!cfg.code && v === cfg.code;
      if (!v) {
        codeMsg.hidden = true;
      } else if (codeOk) {
        codeMsg.hidden = false;
        codeMsg.className = 'vz-msg ok';
        codeMsg.textContent = '✓ Kód přijat. Na první objednávku máš 10 % slevu.';
      } else {
        codeMsg.hidden = false;
        codeMsg.className = 'vz-msg no';
        codeMsg.textContent = 'Tenhle kód neznáme. Zkontroluj ho, nebo pole nech prázdné.';
      }
      progress();
    }
    $('[data-vz-code-btn]').addEventListener('click', checkCode);
    codeIn.addEventListener('change', checkCode);
    codeIn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        checkCode();
      }
    });

    /* ---------- progress ---------- */
    const val = (s) => ($(s) ? $(s).value.trim() : '');
    const hasCompany = () => !!company || (manualCompany && val('#vz-co-name') && val('#vz-co-ico'));
    function progress() {
      const steps = [
        hasCompany() && !!$('[data-vz-biz] input:checked'),
        ['#vz-fn', '#vz-ln', '#vz-em', '#vz-ph'].every((s) => val(s)),
        ['#vz-addr', '#vz-city', '#vz-zip'].every((s) => val(s)),
        !!$('[data-vz-src] input:checked'),
      ];
      $$('.vz-progress span').forEach((el, i) => el.classList.toggle('on', steps[i]));
      const pct = $('[data-vz-pct]');
      if (pct) pct.textContent = `${steps.filter(Boolean).length} / 4`;
    }
    $$('.vz-in').forEach((i) =>
      i.addEventListener('input', () => {
        const f = i.closest('.vz-f');
        f && f.classList.remove('bad');
        progress();
      })
    );

    /* ---------- tags + attribution ---------- */
    function tags() {
      const t = ['B2B', 'vzorky'];
      if (codeOk) t.push('walio');
      const b = $('[data-vz-biz] input:checked');
      if (b) t.push(norm(b.value).replace(/[^a-z]+/g, '-').replace(/^-|-$/g, ''));
      const s = $('[data-vz-src] input:checked');
      if (s) t.push('zdroj-' + norm(s.value).replace(/[^a-z]+/g, '-').replace(/^-|-$/g, ''));
      return t;
    }
    function attribution() {
      const stored = storage.get('tr_attribution', localStorage) || {};
      const p = new URLSearchParams(location.search);
      const out = {};
      $$('[data-vz-trk]').forEach((el) => {
        const k = el.dataset.vzTrk;
        out[k] = p.get(k) || stored[k] || '';
        el.value = out[k];
      });
      return out;
    }

    /* ---------- submit ---------- */
    form.addEventListener('submit', (e) => {
      checkCode();
      let first = null;
      const mark = (sel, ok) => {
        const f = $(sel).closest('.vz-f');
        f.classList.toggle('bad', !ok);
        if (!ok && !first) first = $(sel);
      };
      if (manualCompany) {
        mark('#vz-co-name', val('#vz-co-name'));
        mark('#vz-co-ico', /^\d{8}$/.test(val('#vz-co-ico').replace(/\s/g, '')));
      } else if (!company) {
        $('[data-vz-co-search]').classList.add('bad');
        first = coQ;
      }
      mark('#vz-fn', val('#vz-fn'));
      mark('#vz-ln', val('#vz-ln'));
      mark('#vz-em', /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('#vz-em')));
      mark('#vz-ph', val('#vz-ph').replace(/\D/g, '').replace(/^420/, '').length === 9);
      mark('#vz-addr', val('#vz-addr'));
      mark('#vz-city', val('#vz-city'));
      mark('#vz-zip', val('#vz-zip').replace(/\D/g, '').length === 5);
      const gdpr = $('[data-vz-gdpr]');
      $('[data-vz-gdpr-wrap]').classList.toggle('bad', !gdpr.checked);
      if (!gdpr.checked && !first) first = gdpr;

      if (first) {
        e.preventDefault();
        first.focus({ preventScroll: true });
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      // Valid: fill hidden fields synchronously and let Shopify handle the post (incl. its bot check).
      const co = company || {
        name: val('#vz-co-name'),
        ico: val('#vz-co-ico').replace(/\s/g, ''),
        dic: '',
        addr: '',
      };
      const phone = '+420 ' + val('#vz-ph').replace(/\D/g, '').replace(/^420/, '').replace(/(\d{3})(?=\d)/g, '$1 ');
      const t = tags();
      hidden('company').value = co.name;
      hidden('ico').value = co.ico;
      hidden('dic').value = co.dic;
      hidden('seat').value = co.addr;
      hidden('ares').value = company ? 'ano' : 'ne (vyplněno ručně)';
      hidden('name').value = `${val('#vz-fn')} ${val('#vz-ln')}`;
      hidden('phone').value = phone.trim();
      hidden('walio').value = codeOk ? 'ANO – 10 % na první objednávku' : 'ne';
      hidden('tags').value = t.join(', ');
      const trk = attribution();
      // Come back to this exact page (incl. ?view=… in previews) and show the success state.
      const back = new URLSearchParams(location.search);
      back.set('contact_posted', 'true');
      $('[data-vz-return]').value = `${location.pathname}?${back}#vz-card`;

      const src = $('[data-vz-src] input:checked');
      const biz = $('[data-vz-biz] input:checked');
      storage.set(PENDING_KEY, {
        first_name: val('#vz-fn'),
        last_name: val('#vz-ln'),
        email: val('#vz-em'),
        phone: phone.trim().replace(/\s/g, ''),
        company: co.name,
        ico: co.ico,
        dic: co.dic,
        company_seat: co.addr,
        ares_verified: company ? 'yes' : 'no',
        business_type: biz ? biz.value : '',
        address1: val('#vz-addr'),
        city: val('#vz-city'),
        zip: val('#vz-zip'),
        country_code: 'CZ',
        delivery_note: val('#vz-note'),
        source: src ? src.value : '',
        source_other: other.hidden ? '' : other.value.trim(),
        discount_code: codeIn.value.trim(),
        walio: codeOk ? 'yes' : 'no',
        accepts_marketing: $('[data-vz-news]').checked ? 'yes' : 'no',
        tags: t.join(','),
        ...trk,
        submitted_at: new Date().toISOString(),
        page: location.pathname,
      });
    });

    // Visitors coming from a Walio link get "Walio" preselected.
    const fromWalio = /walio/i.test((storage.get('tr_attribution', localStorage) || {}).utm_source || new URLSearchParams(location.search).get('utm_source') || '');
    const walioChip = $('[data-vz-src] input[value="Walio"]');
    if (fromWalio && walioChip && !$('[data-vz-src] input:checked')) walioChip.checked = true;
    onSource();
    progress();
  }

  /* ---------- after Shopify accepted the form ---------- */
  function finish(done, cfg) {
    const data = storage.get(PENDING_KEY);
    if (!data) return;
    storage.del(PENDING_KEY);
    const txt = done.querySelector('[data-vz-done-text]');
    if (txt && data.address1) {
      txt.textContent =
        `Set pošleme na ${data.address1}, ${data.city} do 3 pracovních dnů. Kdyby bylo potřeba něco upřesnit, ozveme se na ${data.email}.` +
        (data.walio === 'yes' ? ' Slevu 10 % od Walio máš u nás uloženou k firmě.' : '');
    }
    if (cfg.webhook) {
      // A plain form POST (no CORS preflight). Privacy browsers such as Brave drop
      // cross-site sendBeacon calls, so the beacon is only a fallback.
      const body = new URLSearchParams(data);
      fetch(cfg.webhook, { method: 'POST', body, mode: 'no-cors', keepalive: true }).catch(() => {
        if (navigator.sendBeacon) navigator.sendBeacon(cfg.webhook, new URLSearchParams(data));
      });
    }
    done.closest('.vz-card').scrollIntoView({ block: 'start' });
  }

  const boot = () => document.querySelectorAll('.vz').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.vz').forEach(init));
})();
